import React, { useState } from 'react';
import Text from './text';
import NumberFormat from 'react-number-format';

export default function TextInputPhone(props) {
  const { onChange, onValueChange, ...customInputProps } = props;

  const [isInvalid, setIsInvalid] = useState(false);

  const onFormattedValueChange = (values) => {
    //values.value, values,formattedValue, values.floatValue
    if (onChange) {
      const syntheticEvent = {};
      syntheticEvent.target.value = values.formattedValue;
      onChange(syntheticEvent);
    }
    if (onValueChange) {
      onValueChange(values.formattedValue);
    }
    setIsInvalid(values.formattedValue.indexOf('_') !== -1);
  };

  return (
    <NumberFormat
      format='###-###-####'
      mask='_'
      onValueChange={onFormattedValueChange}
      customInput={Text}
      isInvalid={isInvalid}
      feedback={isInvalid ? 'Invalid phone number' : null}
      {...customInputProps}
    />
  );
}